import * as React from 'react';

import type { AnnouncementsAdminClient } from '@/api/announcements-admin-client';
import { HttpAnnouncementsAdminClient } from '@/api/announcements-admin-client.http';

// =============================================================================
// announcements-admin-client-context.tsx — Injection du AnnouncementsAdminClient (DI seam, R15-COM-03).
// =============================================================================
// Permet de substituer le client (double déterministe en test, impl HTTP réelle en prod) sans toucher
// l'UI. Par défaut : l'impl HTTP réelle ; le stub reste injectable via le provider pour les tests. Séparé
// des autres clients : la surface ADMIN du composer d'annonces est un concern distinct (BC communication).

const defaultAnnouncementsAdminClient: AnnouncementsAdminClient =
  new HttpAnnouncementsAdminClient();

const AnnouncementsAdminClientContext =
  React.createContext<AnnouncementsAdminClient>(defaultAnnouncementsAdminClient);

export interface AnnouncementsAdminClientProviderProps {
  client?: AnnouncementsAdminClient | undefined;
  children: React.ReactNode;
}

export function AnnouncementsAdminClientProvider({
  client = defaultAnnouncementsAdminClient,
  children,
}: AnnouncementsAdminClientProviderProps): React.JSX.Element {
  return (
    <AnnouncementsAdminClientContext.Provider value={client}>
      {children}
    </AnnouncementsAdminClientContext.Provider>
  );
}

export function useAnnouncementsAdminClient(): AnnouncementsAdminClient {
  return React.useContext(AnnouncementsAdminClientContext);
}
